import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'seamless-immutable';
import { Card } from '../../components';
import CardMedia from '@material-ui/core/CardMedia';

import Answer from './answer';

class Question extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedAnswers: Immutable({}),
    };
  }

  answerSelectionChanged(answer, event, selected) {
    let selectedAnswers = this.state.selectedAnswers;
    if (this.props.question.isSingleChoice) {
      selectedAnswers = Immutable({});
    }

    if (selected) {
      selectedAnswers = selectedAnswers.set(answer.id, true);
    } else {
      selectedAnswers = selectedAnswers.without(answer.id);
    }

    this.setState({
      selectedAnswers,
    });

    this.props.answerSelectionChanged(this.props.question, selectedAnswers);
  }

  renderQuestionImage() {
    if (!this.props.question.imageUrl) return null;

    return (
      <CardMedia>
        <div style={styles.imageContainer}>
          <img src={this.props.question.imageUrl} style={styles.imageStyle} />
        </div>
      </CardMedia>
    );
  }

  render() {
    if (!this.props.question || !this.props.question.answers) {
      return null;
    }

    return (
      <Card title={this.props.question.text} showAll={this.props.showAll}>
        {this.renderQuestionImage()}
        {this.props.question.answers.filter(a => a && !!a.text).map(answer => <Answer
          answer={answer}
          completed={this.props.completed}
          isSelected={this.state.selectedAnswers.getIn([answer.id])}
          key={answer.id}
          onCheck={this.answerSelectionChanged.bind(this, answer)}
        />)}
      </Card>
    );
  }
}

const styles = {
  imageContainer: {
    maxHeight: 380,
    marginBottom: 20,
    marginTop: 10,
    textAlign: 'center',
    backgroundColor: '#f8f8f8',
  },
  imageStyle: {
    maxWidth: '100%',
    maxHeight: 380,
  },
};

export default Question;



// WEBPACK FOOTER //
// ./src/app/main/test/question.js